import React, { useRef, useEffect } from 'react';
import { clsx } from 'clsx';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'indeterminate'> {
  label?: string;
  indeterminate?: boolean;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  className,
  indeterminate,
  ...props
}, ref) => {
  const internalRef = useRef<HTMLInputElement | null>(null);

  // Merge external ref (from react-hook-form) with internal ref
  useEffect(() => {
    const element = internalRef.current;
    if (element) {
      element.indeterminate = indeterminate || false;

      // Call the external ref if it exists
      if (typeof ref === 'function') {
        ref(element);
      } else if (ref) {
        ref.current = element;
      }
    }
  }, [indeterminate, ref]);

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        className={clsx(
          'h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded',
          className
        )}
        ref={internalRef}
        {...props}
      />
      {label && (
        <label htmlFor={props.id} className="ml-2 block text-sm text-gray-900">
          {label}
        </label>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';